// HACK: This needs to run BEFORE @lwc/synthetic-shadow is loaded
// eslint-disable-next-line @typescript-eslint/unbound-method
const assignedElements_ = HTMLSlotElement.prototype.assignedElements;

// HACK: @lwc/synthetic-shadow overrides slot.assignedElements()
export function assignedElements(
  node: HTMLSlotElement,
  options?: AssignedNodesOptions
): Element[] {
  return assignedElements_.call(node, options);
}

// HACK: This needs to run BEFORE @lwc/synthetic-shadow is loaded
// eslint-disable-next-line @typescript-eslint/unbound-method
const assignedNodes_ = HTMLSlotElement.prototype.assignedNodes;

// HACK: @lwc/synthetic-shadow overrides slot.assignedNodes()
export function assignedNodes(
  node: HTMLSlotElement,
  options?: AssignedNodesOptions
): Node[] {
  return assignedNodes_.call(node, options);
}

// HACK: This needs to run BEFORE @lwc/synthetic-shadow is loaded
// eslint-disable-next-line @typescript-eslint/unbound-method
const children_ = Object.getOwnPropertyDescriptor(
  Element.prototype,
  "children"
);

// HACK: @lwc/synthetic-shadow overrides element.children
export function children(node: HTMLSlotElement): Element[] {
  return Array.from(children_!.get!.call(node));
}

export function assignedSlotNames(template: {
  querySelectorAll(selector: string): NodeList;
}) {
  let slots = Array.from(
    template.querySelectorAll("slot")
  ) as HTMLSlotElement[];
  return slots
    .filter(isSlotAssigned)
    .map((slot) => slot.getAttribute("name") || "default");
}

export function isSlotAssigned(slot: HTMLSlotElement): boolean {
  let [element] = assignedElements(slot);
  if (element) {
    if (element.tagName === "SLOT") {
      return isSlotAssigned(element as HTMLSlotElement);
    }
    return true;
  }
  return children(slot).length > 0;
}
